import { useArrayConstants } from "@/app/hooks/useArrayConstants";
import { useEffect, useState } from "react";

interface ISelectedDateProps {
  selectedSubService?: string;
  selectedServiceIds?: string[];
  setSelecteSubService?: (service_id: string, subservice_id: string) => void;
  excludeHcBath?: boolean;
  excludeAHS?: boolean;
  disabled?: boolean;
}

const QuickServiceFilters: React.FC<ISelectedDateProps> = ({
  selectedSubService,
  selectedServiceIds,
  setSelecteSubService,
  excludeHcBath,
  excludeAHS,
  disabled,
}) => {
  const { serviceList } = useArrayConstants();
  const [dateOptions, setDateOptions] = useState<{ label: string; service_id: string; subservice_id: string }[]>([]);

  useEffect(() => {
    setDateOptions(
      serviceList.filter(
        (item) => !(excludeHcBath && item.label === "HC & Bath") && !(excludeAHS && item.label === "AHS"),
      ),
    );
  }, [serviceList, excludeHcBath, excludeAHS]);

  return (
    <div className="flex justify-end items-center w-full gap-2">
      {dateOptions.map((item) => {
        const isSelected = item?.subservice_id
          ? selectedSubService === item.subservice_id
          : Boolean(selectedServiceIds?.includes(item?.service_id));
        return (
          <button
            key={item.label}
            type="button"
            disabled={disabled}
            onClick={() => setSelecteSubService && setSelecteSubService(item?.service_id, item?.subservice_id)}
            className={`px-6 py-1    whitespace-nowrap flex rounded-full font-medium text-sm ${
              isSelected
                ? " text-[#000000] border-[#000000]  border-[1.5px]"
                : " border-[1px] bg-[#F4F4F4] text-[#6C727F] border-[#E2E2E2] "
            } ${disabled ? " cursor-not-allowed opacity-60" : ""}`}
          >
            <span>{item.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default QuickServiceFilters;
